import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IPromoCodesSlice {
  promoCodeTextFieldValue: string;
  promoCodeFormErrors: string[];
  promoCodesToBeValidated: string[];
  failedUrlParamCodes: string[];
  promoRevalidationPlanId: number | null;

  /**
   * This is used to synchronize the state of the `usePromoValidation` hook with the
   * loading spinner in the Order Summary widget.
   *
   * It would be nice if React Query allowed us to simply reference the mutation's state
   * via `mutationKey`, but it doesn't.
   */
  promoCodeValidationPending: boolean;
  promoCodesIsHiddenFeatureGateEnabled: boolean;
  stashedMonthlyPromoCodes: string[];
}

export const createPromoCodesSliceDefaultValues = (): IPromoCodesSlice => ({
  promoCodeTextFieldValue: '',
  promoCodeFormErrors: [],
  promoCodesToBeValidated: [],
  failedUrlParamCodes: [],
  promoRevalidationPlanId: null,
  promoCodeValidationPending: false,
  promoCodesIsHiddenFeatureGateEnabled: false,
  stashedMonthlyPromoCodes: [],
});

export const createPromoCodesSlice: StateCreator<IPromoCodesSlice> = () => createPromoCodesSliceDefaultValues();

export type PromoCodesPageStore = UseBoundStore<StoreApi<IPromoCodesSlice>>;

export const createPromoCodesHooks = (pageStore: PromoCodesPageStore) => {
  return {
    usePromoCodeTextFieldValue: () => pageStore((state) => state.promoCodeTextFieldValue),
    usePromoCodeFormErrors: () => pageStore((state) => state.promoCodeFormErrors),
    usePromoCodeValidationPending: () => pageStore((state) => state.promoCodeValidationPending),
    useIsHidePromoCodesEnabled: () => pageStore((state) => state.promoCodesIsHiddenFeatureGateEnabled),
  };
};

export type PromoCodesHooks = ReturnType<typeof createPromoCodesHooks>;
